<template>
  <footer class="bg-dark text-white text-center">
    <div class="py-2">
      <span class="px-1">DevBuds</span>
      <span>تصميم وتطوبر</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>

<style>
</style>